import { createAsyncAction, AppThunk } from 'typesafe-actions';

import generateLogger from '@travel/logger';
import { isNotEmptyArray } from '@travel/utils';

import {
  DeparturePlace,
  SearchAreasErrors,
  SearchAreasResponse,
  SearchAreaAccommodations,
} from 'SearchAreas-Types';
import { fetch } from './apis';
import { getDepartureAreas } from './selectors';

const logger = generateLogger();

export const fetchDepartureAreasAsync = createAsyncAction(
  'FETCH_DEPARTURE_AREAS_REQUEST',
  'FETCH_DEPARTURE_AREAS_SUCCESS',
  'FETCH_DEPARTURE_AREAS_FAILURE',
)<undefined, Array<DeparturePlace>, SearchAreasErrors>();

export const fetchSearchAreaResponseByDepartureAreaAsync = createAsyncAction(
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_REQUEST',
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_SUCCESS',
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_FAILURE',
)<undefined, SearchAreasResponse, SearchAreasErrors>();

export const fetchSearchAreaResponseByAccommodationAreaAsync = createAsyncAction(
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_REQUEST',
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_SUCCESS',
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_FAILURE',
)<undefined, SearchAreasResponse, SearchAreasErrors>();

export const fetchPlacesOfStayAsync = createAsyncAction(
  'FETCH_PLACES_OF_STAY_REQUEST',
  'FETCH_PLACES_OF_STAY_SUCCESS',
  'FETCH_PLACES_OF_STAY_FAILURE',
)<undefined, SearchAreaAccommodations, SearchAreasErrors>();

export const fetchDepartureAreas = (): AppThunk => async (dispatch, getState, { apiClient }) => {
  try {
    const existingDepartures = getDepartureAreas(getState());
    if (isNotEmptyArray(existingDepartures)) {
      dispatch(fetchDepartureAreasAsync.success(existingDepartures));
      return;
    }
    dispatch(fetchDepartureAreasAsync.request());

    const fetchedSearchAreaResponse = await fetch(apiClient);
    dispatch(fetchDepartureAreasAsync.success(fetchedSearchAreaResponse.departures));
  } catch (error) {
    logger.error(error);
    dispatch(fetchDepartureAreasAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchSearchAreaResponseByDepartureArea = (departureArea: string): AppThunk => async (
  dispatch,
  _getState,
  { apiClient },
) => {
  try {
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.request());
    let fetchedSearchAreaResponse = await fetch(apiClient, departureArea);
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.success(fetchedSearchAreaResponse));
  } catch (error) {
    logger.error(error);
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchPlacesOfStay = (
  departureArea: string,
  accommodationArea: string,
): AppThunk => async (dispatch, _getState, { apiClient }) => {
  try {
    dispatch(fetchPlacesOfStayAsync.request());
    let fetchedSearchAreaResponse = await fetch(apiClient, departureArea, accommodationArea);
    dispatch(fetchPlacesOfStayAsync.success(fetchedSearchAreaResponse.accommodations));
  } catch (error) {
    logger.error(error);
    dispatch(fetchPlacesOfStayAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchSearchAreaResponseByAccommodationArea = (
  accommodationArea: string,
): AppThunk => async (dispatch, _getState, { apiClient }) => {
  try {
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.request());

    let fetchedSearchAreaResponse = await fetch(apiClient, undefined, accommodationArea);
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.success(fetchedSearchAreaResponse));
  } catch (error) {
    logger.error(error);
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.failure(error as SearchAreasErrors));
  }
};
